// extracted by mini-css-extract-plugin
export default {"pressButton":"zoho-status_pressButton__zoEKw","contentWrapper":"zoho-status_contentWrapper__T0l7K","loading":"zoho-status_loading__lzj1-","l":"zoho-status_l__66vu5"};